import { Injectable } from "@angular/core";
import { AccountingPlanEntity } from "@arch/domain/entity";

@Injectable({
    providedIn: "root"
})
export class AccountingPlanService {
    public accountingPlan: AccountingPlanEntity | null = null;
    public features: Record<string, boolean> = {
        IAContador: false,
        IAShortcutsAccounting: false,
        IAEmployee: false,
        AutomaticParameterization: false,
        AnalysisPlus: false
    };

    constructor() {}

    init({ accountingPlan }: { accountingPlan: AccountingPlanEntity }): void {
        this.reset();
        if (!accountingPlan) {
            return;
        }
        this.accountingPlan = accountingPlan;
        this.setFeatures();
    }

    private setFeatures(): void {
        const features = Object.keys(this.features);
        for (const feature of features) {
            this.features[feature] = this.accountingPlan.isContractedFeature({
                name: feature
            });
        }
    }

    public reset(): void {
        this.accountingPlan = null;
        const features = Object.keys(this.features);
        for (const feature of features) {
            this.features[feature] = false;
        }
    }

    public setFeature(name: string, value: boolean): void {
        this.features[name] = value;
    }
}
